import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import appConfig from "../../config/appConfig";
import { ToastBottomEnd } from "./Toast";
import {
  toastAssignClaimSuccessMessageConfig,
  toastErrorMessageWithParameterConfig,
  toastRejectTreatmentClaimSuccessMessageConfig,
  toastValidateTreatmentClaimSuccessMessageConfig,
} from "../../config/toastConfig";
import { verifyTokenExpire } from "../../middleware/verifyToken";
import { useTranslation } from "react-i18next";
import { verifyPermission } from "helpers/permission";
import { formatSelectOption, localize } from "helpers/function";
import { useParams } from "react-router-dom";

const ReasonModal = (props) => {
  const defaultError = {
    unit_id: [],
  };

  //usage of useTranslation i18n
  const { t, ready } = useTranslation();
  const [description, setDescription] = useState("");
  const [startRequest, setStartRequest] = useState(false);
  const [JustFiles, setJustFiles] = useState([]);
  const [error, setError] = useState([]);
  const [error1, setError1] = useState(defaultError);
  const [transfer, setTransfer] = useState("no");
  const [notifyCustomer, setNotifyCustomer] = useState(true);

  //Transfert claim to unit
  const [unitsData, setUnitsData] = useState({});
  const [unit, setUnit] = useState(null);
  const [data, setData] = useState({ unit_id: null });

  const { id } = useParams();

  const endPointConfig = {
    PRO: {
      plan: "PRO",
      edit: () =>
        `${appConfig.apiDomaine}/getUnitsPrediction`.replace(/ /g, "%20"),
      update: (id) =>
        `${appConfig.apiDomaine}/transfer-claim-to-circuit-unit/${id}`,
      edit2: (id) =>
        `${appConfig.apiDomaine}/transfer-claim-to-circuit-unit/${id}`,
    },
    MACRO: {
      plan: "MACRO",
      edit: () =>
        `${appConfig.apiDomaine}/getUnitsPrediction`.replace(/ /g, "%20"),
      update: (id) =>
        `${appConfig.apiDomaine}/transfer-claim-to-circuit-unit/${id}`,
      edit2: (id) =>
        `${appConfig.apiDomaine}/transfer-claim-to-circuit-unit/${id}`,
    },
    HUB: {
      plan: "HUB",
      edit: (id) => `${appConfig.apiDomaine}/transfer-claim-to-unit/${id}`,
      update: (id) => `${appConfig.apiDomaine}/transfer-claim-to-unit/${id}`,
    },
  };

  useEffect(() => {
    async function fetchData() {
      if (verifyTokenExpire()) {
        axios
          .post(endPointConfig[props.plan].edit(`${props.id}}`), {
            description: props.claim.description,
            object: localize(props.claim.claim_object.name),
          })
          .then((response) => {
            
            if (response.data.length === 0) {
              axios
                .get(endPointConfig[props.plan].edit2(`${id}}`))
                .then((response) => {
                  let newUnit = Object.values(response.data.units);
                  setUnitsData(
                    formatSelectOption(newUnit, "name", "fr")
                  );
                })
                .catch((error) => console.log("Something is wrong"));
            } else {
              let newUnit = Object.values(response.data);
              setUnitsData(formatSelectOption(newUnit, "name", "fr"));
            }
          })
          .catch((error) => {
            axios
              .get(endPointConfig[props.plan].edit2(`${id}`))
              .then((response) => {
                let newUnit = Object.values(response.data.units);
                setUnitsData(formatSelectOption(newUnit, "name", "fr"));
              })
              .catch((error) => console.log("Something is wrong"));
          });
         
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    setNotifyCustomer(true);
  }, [props.id, props.action]);

  useEffect(() => {
    if (transfer === "yes") {
      setNotifyCustomer(false);
    }
  }, [transfer]);

  const resetNotifyCustomer = () => {
    setNotifyCustomer(true);
  };

  const handleCloseModal = () => {
    resetNotifyCustomer();
    props.onClose();
  };

  const onChangeUnits = (selected) => {
    const newData = { ...data };
    newData.unit_id = selected ? selected.value : null;
    setUnit(selected);
    setData(newData);
  };

  const sendData = () => {
    setStartRequest(true);
    if (verifyTokenExpire()) {
      if (props.action === "reject") {
        axios
          .put(
            `${appConfig.apiDomaine}/claim-awaiting-treatment/${props.id}/rejected`,
            { rejected_reason: description }
          )
          .then((response) => {
            setStartRequest(false);
            resetNotifyCustomer();
            ToastBottomEnd.fire(toastAssignClaimSuccessMessageConfig());
            props.isEscalade
              ? (window.location.href = `/process/unit-claims`)
              : (window.location.href = `/process/unit-claims`);
          })
          .catch((error) => {
            setStartRequest(false);
            if (error.response.data.code === 403) {
              ToastBottomEnd.fire(
                toastErrorMessageWithParameterConfig(
                  t("Vous ne pouvez pas effectuer cette opération.") +
                    t("Le nombre tolérable est dépassé")
                )
              );
            } else {
              setError(error.response.data.error.rejected_reason);
            }
          });
      } else if (props.action === "validateReject") {
        let endpoint = ``;
        if (props.plan === "MACRO" || props.plan === "PRO")
          endpoint = `${appConfig.apiDomaine}/claim-awaiting-validation-my-institution/${props.id}/invalidate`;
        else if (props.plan === "HUB")
          endpoint = `${appConfig.apiDomaine}/claim-awaiting-validation-any-institution/${props.id}/invalidate`;
        axios
          .put(endpoint, { invalidated_reason: description })
          .then((response) => {
            setStartRequest(false);
            resetNotifyCustomer();
            ToastBottomEnd.fire(
              toastRejectTreatmentClaimSuccessMessageConfig()
            );
            props.isEscalade
              ? (window.location.href = `/process/claim-pending-to-validated`)
              : (window.location.href = `/process/claim-to-validated`);
          })
          .catch((error) => {
            setStartRequest(false);
            setError(error.response.data.error.invalidated_reason);
          });
      } else if (props.action === "validateSolution") {
        let endpoint = "";
        if (props.plan === "MACRO" || props.plan === "PRO")
          endpoint = `${appConfig.apiDomaine}/claim-awaiting-validation-my-institution/${props.id}/validate`;
        else if (props.plan === "HUB")
          endpoint = `${appConfig.apiDomaine}/claim-awaiting-validation-any-institution/${props.id}/validate`;
        axios
          .put(endpoint, {
            solution_communicated: description,
            mail_attachments: JustFiles,
            notify_customer: transfer === "yes" ? false : notifyCustomer,
            // Si l'utilisateur ne souhaite pas retransférer à une autre unité, on ne doit pas envoyer d'unité.
            unit_id: transfer === "yes" ? data.unit_id : null
          })
          .then((response) => {
            setStartRequest(false);
            resetNotifyCustomer();
            ToastBottomEnd.fire(
              toastValidateTreatmentClaimSuccessMessageConfig()
            );
            props.isEscalade
              ? (window.location.href = `/process/claim-pending-to-validated`)
              : (window.location.href = `/process/claim-to-validated`);
          })
          .catch((error) => {
            setStartRequest(false);
            console.log(error);
            ToastBottomEnd.fire(
              toastErrorMessageWithParameterConfig(t("Erreur lors du traitement"))
            );
            setError(error.response.data.error.solution_communicated);
          });
      }
    }
  };

  const SelectComponent = () => {

    return <div className="kt-wizard-v2__review-content">
      <div
        className={
          error1.unit_id.length
            ? "form-group validated"
            : "form-group"
        }
      >
        <label>{t("Unité")}</label>
        <Select
          isClearable
          value={unit}
          onChange={onChangeUnits}
          options={unitsData}
          placeholder={t(
            "Veuillez sélectionner l'unité de traitement"
          )}
        />
        {error1.unit_id.length
          ? error1.unit_id.map((error, index) => (
              <div
                key={index}
                className="invalid-feedback"
              >
                {error}
              </div>
            ))
          : ""}
      </div>
    </div>

    return null;
  };

  return ready ? (
    <div
      className="modal fade show"
      id="kt_modal_4_2"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      style={{ display: "block", paddingRight: "17px" }}
      aria-modal="true"
    >
      <div className="modal-dialog modal-xl" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              {props.reasonTitle}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label={t("Close")}
              onClick={handleCloseModal}
            />
          </div>
          <div className="modal-body">
            {
              props.action === "validateSolution" && !props.isEscalade && (
                <div>
                  <label>{t("Voulez-vous retransférer la réclamation à une autre unité pour un nouveau traitement ? ")}</label>
                  <div className="d-flex col-md-6 mb-4 order-1 order-md-2">
                    <span className="kt-switch order-2 order-md-1">
                      <label>
                        <input
                            type="checkbox"
                            checked={transfer === "yes" ? true : false}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setTransfer(checked ? "yes" : "no");

                              if (checked) {
                                setNotifyCustomer(false);
                              }

                              // Quand on repasse à false, on doit vider l'unité sélectionnée.
                              if (!checked) {
                                setUnit(null);
                                setData({ unit_id: null });
                              }
                            }}
                        />
                        <span />
                      </label>
                    </span>
                  </div>
                </div>
              )
            }
            {props.action === "validateSolution" && transfer !== "yes" && (
              <div className="mt-3">
                <label>
                  Voulez-vous envoyer une notification au client ?
                </label>
                <div className="d-flex col-md-6 mb-2 order-1 order-md-2">
                  <span className="kt-switch order-2 order-md-1">
                    <label>
                      <input
                        type="checkbox"
                        checked={notifyCustomer}
                        onChange={(e) => setNotifyCustomer(e.target.checked)}
                      />
                      <span />
                    </label>
                  </span>
                </div>
              </div>
            )}
              
            {transfer === "yes" && (
              <hr />
            )}
            {
              transfer=== "yes" && props.action=== "validateSolution" && (
                <SelectComponent />
              )
            }
            {
              (transfer === "no" || (transfer === "yes" && props.action !== "validateSolution")) && (
                <form>
                  <div className={error.length ? "form-group validated" : ""}>
                    <label htmlFor="message-text" className="form-control-label">
                      {props.reasonLabel}:
                    </label>
                    <textarea
                      className={
                        error.length ? "form-control is-invalid" : "form-control"
                      }
                      id="message-text"
                      // placeholder={t("Veuillez entrer le message à communiquer au réclamant")}
                      placeholder={
                        props.action === "reject"
                          ? t("Veuillez renseigner le motif du rejet")
                          : props.action === "validateReject"
                          ? t("Veuillez renseigner le motif du rejet")
                          : t(
                              "Veuillez entrer le message à communiquer au réclamant"
                            )
                      }
                      onChange={(e) => setDescription(e.target.value)}
                    />
                    {error.map((error, index) => (
                      <div key={index} className="invalid-feedback">
                        {error}
                      </div>
                    ))}
                  </div>
                  {props.action === "validateSolution" && (
                    <div className={error.length ? "form-group validated" : "mt-4"}>
                      <label htmlFor="message-text" className="form-control-label">
                        Pièces justificatives de la solution :
                        <span
                          style={{
                            fontSize: "12px",
                            color: "red",
                            marginLeft: "4px",
                            display: "inline-block",
                          }}
                        >
                          (Veuillez cocher les pièces à joindre à la solution
                          communiquée)
                        </span>
                      </label>
                      <div className="kt-wizard-v2__review">
                        {props?.claim?.files_at_treatment?.length ? (
                          props?.claim?.files_at_treatment?.map?.((file, index) => (
                            <div className="mb-0 row ml-2">
                              <div className="">
                                <span
                                  style={{ transform: "scale(0.8,0.8)" }}
                                  className="kt-switch"
                                >
                                  <label>
                                    <input
                                      style={{}}
                                      id="inactivity_control"
                                      type="checkbox"
                                      value={file.id}
                                      checked={JustFiles.includes(file?.id)}
                                      onChange={(e) => {
                                        let value = e.target.value;
                                        if (e.target.checked) {
                                          setJustFiles((prev) =>
                                            prev.concat(value)
                                          );
                                        } else {
                                          setJustFiles((prev) =>
                                            prev
                                              .slice(0, prev.indexOf(value))
                                              .concat(
                                                prev.slice(prev.indexOf(value) + 1)
                                              )
                                          );
                                        }
                                      }}
                                    />
                                    <span />
                                  </label>
                                </span>
                              </div>
                              <a
                                href={`${appConfig.apiDomaine}${file.url}`}
                                download={true}
                                target={"_blank"}
                              >
                                <label
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "300",
                                    marginTop: "-4px",
                                  }}
                                  className="col-12  col-form-label"
                                >
                                  {t(file.title)}
                                </label>
                              </a>
                            </div>
                          ))
                        ) : (
                          <div className="kt-wizard-v2__review-item">
                            <div className="kt-wizard-v2__review-title">
                              {t("Pas de pièce jointe")}
                            </div>
                          </div>
                        )}
                      </div>
                      <div></div>
                      {error.map((error, index) => (
                        <div key={index} className="invalid-feedback">
                          {error}
                        </div>
                      ))}
                    </div>
                  )}
                </form>
              )
            }
          </div>
          <div className="modal-footer">
            <button
              id={"close-button-reason"}
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
              onClick={handleCloseModal}
            >
              {t("Fermer")}
            </button>
            {!startRequest ? (
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => sendData()}
              >
                {t("Envoyer")}
              </button>
            ) : (
              <button
                className="btn btn-primary kt-spinner kt-spinner--left kt-spinner--md kt-spinner--light"
                type="button"
                disabled
              >
                {t("Chargement")}...
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default ReasonModal;
